import React, { Component } from "react";
import "./App.css";
import { connect } from "react-redux";
import MainRoute from "./Navigation/MainRoute";

class App extends Component {
  componentDidMount() {
    document.body.style.background = "#f2f2f0";
  }

  render() {
    return (
      <>
        <MainRoute />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
